import { FEED_MAX, STAT_TO_BOX_FIELD } from './gameConstants';

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const fileUrl = (path) => `${API_URL}/api/files/${path}`;

// Jersey-number order everywhere; players without a number go last, ties by name.
export const sortByJersey = (a, b) => {
  const parse = (s) => {
    const n = parseInt(String(s ?? '').trim(), 10);
    return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY;
  };
  const ja = parse(a?.jersey_number);
  const jb = parse(b?.jersey_number);
  if (ja !== jb) return ja - jb;
  return (a?.name || '').localeCompare(b?.name || '');
};

// M:SS, clamped at zero.
export const formatClock = (secs) => {
  const safe = Math.max(0, secs ?? 0);
  const m = Math.floor(safe / 60);
  const s = safe % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
};

export const periodLabel = (q) => (q > 4 ? `OT${q - 4}` : `Q${q}`);

export const teamKeyOf = (team) => (team === 'a' ? 'team_a' : 'team_b');

export const otherSide = (team) => (team === 'a' ? 'b' : 'a');

export const sortByPoints = (rows) => [...rows].sort((a, b) => (b.pts || 0) - (a.pts || 0));

// Walk the newest-first feed, decrementing each player's cumulative total so
// every entry shows the running count at the moment it was recorded.
export const computeRunningTotals = (recentEntries, boxscore) => {
  const feedEntries = recentEntries.slice(0, FEED_MAX);
  const counters = new Map();
  const totals = new Map();
  for (const e of feedEntries) {
    const boxField = STAT_TO_BOX_FIELD[e.stat_type];
    if (!boxField) continue;
    const key = `${e.player_id}:${boxField}`;
    if (!counters.has(key)) {
      const p = (boxscore?.[teamKeyOf(e.team)] || []).find(x => x.player_id === e.player_id);
      counters.set(key, p ? Number(p[boxField] || 0) : 0);
    }
    const current = counters.get(key);
    if (current > 0) {
      totals.set(e.id, current);
      counters.set(key, current - 1);
    }
  }
  return { feedEntries, totals };
};
